import { DB } from '@/extensions/db'
import { newGuid } from '../utils'

let instance = null

export class ModbusData {
  constructor () {
    instance = instance || this

    this._table = DB.modbusData

    return instance
  }

  /**
   * @param [string] options.modbusDeviceId
   * @param [string] options.cmdType
   * @param [string] options.address
   * @param [string] options.regNum
   *
   * @returns [number] device id
   */
  async add (options) {
    return this._table.add({
      id: newGuid(),
      modbusDeviceId: options.modbusDeviceId,
      cmdType: options.cmdType,
      address: options.address,
      regNum: options.regNum
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async all () {
    return this._table.toArray()
  }

  async update (id, data) {
    return this._table.update(id, {
      cmdType: data.cmdType,
      address: data.address,
      regNum: data.regNum
    })
  }

  async delete (id) {
    return this._table.delete(id)
  }

  async modbusId (id) {
    return this._table.where({ modbusDeviceId: id }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/modbus-data.js